export enum Documents {
  InternalRules,
  PerformanceFees
}
